export default __webpack_public_path__ + "static/media/1325 CNC BUGWANG GTC.6bcd5c9a.png";